import { buildModelManager } from "../builder.js";
const DefaultWebhookSubscriptionSelection = {
  __typename: true,
  id: true,
  changeType: true,
  clientState: true,
  createdAt: true,
  expirationDateTime: true,
  isActive: true,
  lastRenewed: true,
  notificationUrl: true,
  renewalAttempts: true,
  renewalError: true,
  resource: true,
  subscriptionId: true,
  updatedAt: true
};
const modelApiIdentifier = "webhookSubscription";
const pluralModelApiIdentifier = "webhookSubscriptions";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySubscriptionId",
    findByField: "subscriptionId",
    findByVariableName: "subscriptionId",
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySubscriptionId",
    findByField: "subscriptionId",
    findByVariableName: "subscriptionId",
    modelApiIdentifier,
    defaultSelection: DefaultWebhookSubscriptionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWebhookSubscription",
    operationReturnType: "CreateWebhookSubscription",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      webhookSubscription: { required: false, type: "CreateWebhookSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWebhookSubscriptions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateWebhookSubscriptionsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "action",
    operationName: "updateWebhookSubscription",
    operationReturnType: "UpdateWebhookSubscription",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      webhookSubscription: { required: false, type: "UpdateWebhookSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWebhookSubscriptions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateWebhookSubscriptionsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "action",
    operationName: "deleteWebhookSubscription",
    operationReturnType: "DeleteWebhookSubscription",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWebhookSubscriptions",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWebhookSubscription",
    operationReturnType: "UpsertWebhookSubscription",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      webhookSubscription: { required: false, type: "UpsertWebhookSubscriptionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWebhookSubscriptionResult": { hasReturnType: false },
      "... on UpdateWebhookSubscriptionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWebhookSubscriptions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertWebhookSubscriptionsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWebhookSubscriptionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "webhookSubscriptionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WebhookSubscriptionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWebhookSubscriptionSelection,
  operations
);
export {
  DefaultWebhookSubscriptionSelection,
  WebhookSubscriptionManager
};
//# sourceMappingURL=WebhookSubscription.js.map
